const GROUPS = [
  ["Lumiere", [["exposure", "Exposition"], ["contrast", "Contraste"], ["highlights", "Hautes lumieres"], ["shadows", "Ombres"], ["whites", "Blancs"], ["blacks", "Noirs"]]],
  ["Couleur", [["temperature", "Temperature"], ["tint", "Teinte"], ["vibrance", "Vibrance"], ["saturation", "Saturation"]]],
  ["Detail", [["sharpness", "Nettete", 0]]],
];

function Slider({ k, label, min = -100, value, onChange, onCommit }) {
  const pct = ((value - min) / (100 - min)) * 100;
  const zero = ((0 - min) / (100 - min)) * 100;
  return (
    <div className="group" onDoubleClick={() => { onChange(k, 0); onCommit(); }}>
      <div className="flex items-center justify-between mb-1">
        <label className="text-[11px] text-[#94A3B8] group-hover:text-white transition-colors">{label}</label>
        <span className={`text-[10px] font-mono tabular-nums ${value ? "text-[#F97316]" : "text-[#4A5568]"}`} data-testid={`slider-value-${k}`}>{value > 0 ? "+" : ""}{value}</span>
      </div>
      <div className="relative h-4 flex items-center">
        <div className="absolute inset-x-0 h-[3px] rounded bg-[#1A2332]" />
        <div className="absolute h-[3px] rounded bg-[#F97316]" style={{ left: `${Math.min(pct, zero)}%`, width: `${Math.abs(pct - zero)}%` }} />
        <input type="range" min={min} max={100} value={value} onChange={(e) => onChange(k, +e.target.value)} onPointerUp={onCommit} onKeyUp={onCommit}
          className="studio-range relative w-full" data-testid={`slider-${k}`} aria-label={label} />
      </div>
    </div>
  );
}

export function AdjustmentPanel({ adj, onChange, onCommit }) {
  return (
    <div className="space-y-5" data-testid="adjustment-sliders">
      {GROUPS.map(([title, items]) => (
        <div key={title}>
          <h4 className="text-[10px] uppercase tracking-[0.2em] text-[#64748B] font-semibold mb-3">{title}</h4>
          <div className="space-y-3">
            {items.map(([k, label, min]) => <Slider key={k} k={k} label={label} min={min ?? -100} value={adj[k] || 0} onChange={onChange} onCommit={onCommit} />)}
          </div>
        </div>
      ))}
      <p className="text-[10px] text-[#4A5568] leading-relaxed">Double-cliquez un curseur pour le remettre a zero. Corrections globales uniquement : aucun lissage de peau ni deformation, l'identite des personnes est preservee.</p>
    </div>
  );
}
